module.exports = __webpack_public_path__ + "static/media/rocket.0f9a3c35.png";